// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"Image_imageWrapper__1iq0u","skeletonLoader":"Image_skeletonLoader__2RIK6","error":"Image_error__3OH_d"};